export { default as GenericEdge } from './generic';
